import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Typography,
    Box
} from '@mui/material';

const StockDetailsModal = ({ open, onClose, product }) => {
    if (!product) return null;

    const variants = product.variants || [];
    const totalStock = product.stock || 0;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6">Stock : {product.name}</Typography>
                    <Chip
                        label={`Total: ${totalStock}`}
                        color={totalStock > 0 ? "success" : "error"}
                        variant="outlined"
                    />
                </Box>
            </DialogTitle>
            <DialogContent>
                {variants.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                        Pas de déclinaisons pour ce produit.
                    </Typography>
                ) : (
                    <TableContainer component={Paper} elevation={0} variant="outlined">
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Variante</TableCell>
                                    <TableCell align="right">Stock Disponible</TableCell>
                                    <TableCell align="right">Statut</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {variants.map((variant) => (
                                    <TableRow key={variant.id}>
                                        <TableCell component="th" scope="row">
                                            {variant.name}
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography fontWeight="medium">
                                                {variant.stock}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Chip
                                                label={variant.stock > 0 ? 'En stock' : 'Rupture'}
                                                color={variant.stock > 0 ? 'success' : 'error'}
                                                size="small"
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fermer</Button>
            </DialogActions>
        </Dialog>
    );
};

export default StockDetailsModal;
